import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useActiveGroups } from "@/components/group-trips/useGroupMembership";

const positive = (value) => (Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : 0);

/**
 * The traveller's unread messages for the app's Messages tab: the bookings'
 * conversations with their partners (the count My bookings shows, GET
 * /conversations/summary) and the groups' (the count of the group bubble),
 * read again on every new screen. A failed read counts nothing.
 */
export default function useTravellerUnread() {
  const { user } = useAuth() || {};
  const userId = user?.user_id;
  const { pathname } = useLocation();
  const groups = useActiveGroups(userId, pathname);
  const [bookings, setBookings] = useState(0);
  useEffect(() => {
    if (!userId) { setBookings(0); return undefined; }
    let live = true;
    api.get("/conversations/summary")
      .then((r) => {
        if (!live) return;
        const rows = Array.isArray(r.data?.bookings) ? r.data.bookings : [];
        setBookings(rows.reduce((sum, row) => sum + positive(row.unread), 0));
      })
      .catch(() => { if (live) setBookings(0); });
    return () => { live = false; };
  }, [userId, pathname]);
  return bookings + groups.reduce((sum, group) => sum + (Number.isInteger(group.unread) ? positive(group.unread) : 0), 0);
}
